import React from 'react';
import './Pokerwatch_new.css';
import moment from 'moment';
import $ from 'jquery';
import Suggestions from './Suggestions';
export const FileUploadDetails =(props) => {
    const {uploadingFileList,enableFileProps,memeTypeStatus,uploading,downloadFile,fileDetailsList,onChangeHandler, uploadedFileList,deleteFile,maxSelectFileStatus,enableProps,fileUploadErrorMessage} = props;
    return (<div>
      <div style={{ overflowY: 'auto' }}>
        <table className="pokerwatch-resp-table pw_file_list_table">

          <thead className="resp-table-head pw_file_list_table_header">
            <tr className="resp-table-tr">
              <th className="pokerwatch-upload-table-th" style={{ width: '198px' }}>Name </th>
              <th className="pokerwatch-upload-table-th" style={{ width: '72px' }}>Size </th>
              <th className="pokerwatch-upload-table-th" style={{ width: '79px' }}>Date</th>
              <th className="pokerwatch-upload-table-th" style={{ width: '70px' }}>Status</th>
              <th className="pokerwatch-upload-table-th" style={{ width: '28px' }}> </th>
            </tr>
          </thead>
          <tbody data-e2e="tableData" className="resp-table-body file-list-table" style={{ maxHeight: '300px', minHeight: '250px', overflowY: 'auto' }}>
            {uploadingFileList!=null && uploadingFileList.map((item, key) => {
              return (<tr key={key} className="resp-table-tr">
                  <td className="pokerwatch-upload-table-td" style={{ width: '220px' }}>{item.name}</td>
                  <td className="pokerwatch-upload-table-td" style={{ width: '70px' }}>{item.size < 1024 ? item.size + 'B' : Math.trunc(item.size / 1024) + 'KB'}</td>
                  <td className="pokerwatch-upload-table-td" style={{ width: '97px' }}> {moment().format("DD.MM.YYYY")}</td>
                  <td className="pokerwatch-upload-table-td" style={{ width: '90px' }}>{uploading ? <span style={{ color: '#6B6B6B' }}>{'uploading'}<i className="fa fa-xs fa-spinner"></i></span> : <span style={{ color: 'red' }}>{'Not Uploaded'}</span>}</td>
                  <td className="pokerwatch-upload-table-td" ><i className="fa fa-trash fa-lg" onClick={e => this.deleteFileList(e, item)}></i></td>
                </tr>)
            })}
            {fileDetailsList.map((item, key) => {
              return (<tr key={key} className="resp-table-tr">
                  <td className="pokerwatch-upload-table-td" style={{ width: '200px' }}>{item.fileName}</td>
                  <td className="pokerwatch-upload-table-td" style={{ width: '70px' }}>{item.size < 1024 ? item.size + 'B' : Math.trunc(item.size / 1024) + 'KB'}</td>
                  <td className="pokerwatch-upload-table-td" style={{ width: '81px' }}> {moment(item.createdDate).format("DD.MM.YYYY")}</td>
                  <td className="pokerwatch-upload-table-td" style={{ width: '70px', color: 'red' }}>{item.status}</td>
                  <td className="pokerwatch-upload-table-td"><span style={{ marginRight: '5px', cursor: 'pointer' }}>
                    <i className="fa fa-lg fa-ellipsis-v" onClick={() => enableFileProps(item, key)}></i>
                    {enableProps && enableProps.status && enableProps.key === key ? <FileProps file={item} downloadFile={downloadFile} deleteFile={deleteFile} /> : ''}
                  </span></td>
                  
                </tr>)})}
          </tbody>
        </table>

      </div>
      <div>
        <span className="poker-watch-error">{fileUploadErrorMessage}</span>
        {!maxSelectFileStatus ? <span className="poker-watch-error">You cannot select more than 10 files</span> : (memeTypeStatus ? '' : <span className="poker-watch-error">Only CSV files allowed to upload</span>)}
      </div>
      <div className="file-upload-input" style={
        (uploadedFileList !== null && uploadedFileList.length > 2) || (fileDetailsList !== null && fileDetailsList.length > 2) ? { marginTop: '10px' } : {}}>
        <button className="poker-watch-choose-file-button" onClick={() => $("#pw-file-uploader2").click()}>Choose File   <input type="file" id="pw-file-uploader2" style={{ display: 'none' }} name="myfile" onChange={onChangeHandler} multiple /> </button>
      </div>
    </div>)
}
export const FileUploadComponent = props => {
    console.log('userDirectory', props)
    const { onChangeHandler } = props;
  
    return <div className="file-upload-content" >
      <i className="fa fa-file-alt fa-4x upload-file-icon"
        onClick={() => $("#pw-file-uploader").click()}
        style={{ marginLeft: '3rem',cursor:'pointer' }}>
        <input type="file" id="pw-file-uploader" style={{ display: 'none' }} onChange={onChangeHandler} multiple></input>
  
      </i>
      <span ><a style={{ color: 'red',cursor:'pointer' }} onClick={() => $("#pw-file-uploader").click()} >Click</a> to upload your files</span>
  
  
    </div>
  }
  export const FileProps = props => {
    console.log('userDirectory', props)
    const { file, downloadFile, deleteFile } = props;
  
    return <div className="user-file-prop-div" style={props.customStyle}>
      <span onClick={(e) => deleteFile(e, file.fileName)}>Delete File</span>
      <span onClick={(e) => downloadFile(e, file.fileName)}> Download File</span>
  
    </div>
  }

export const UserEditDiv = props => {
    console.log('userDirectory', props)
    const { openDialogBox } = props
    return <div className="user-edit-div">
        <span data-e2e="edit-details" onClick={e => openDialogBox('editUser')}>Edit Details</span>
        <span data-e2e="change-role" onClick={e => openDialogBox('changeRole')}>Change Role</span>
        <span data-e2e="login-Ip-history" onClick={e => openDialogBox('viewHistory')}>Login & IP History</span>
        <span data-e2e="delete-user" sonClick={e => openDialogBox('deleteUser')}>Delete User</span>

    </div>
}
export const CustomMobileModal = (props) => {

    const { isDialogOpen, isButtonsShow, title, dataType, cancelDialog, actionPerform, errorMessage, isError, createButtonLable, createButtonStyleName } = props;
    if (!isDialogOpen) {
        return ''
    }
    return <div className="custom-mobile-modal">
        <div className="custom-mobile-modal-header-details">
             <span className="pw-filter-mobile-setting-span"> {title}</span> <i className="fa fa-lg fa-times" style={{ float: 'right', marginRight: '1rem' }} onClick={e => cancelDialog(e, { dataType })}></i>
        </div>
        {props.children}
        <span style={{ color: 'red' }}>{errorMessage} </span>
        {isButtonsShow && <div className="poker-watch-custom-mobile-modal-buttons-div">
            <button className={createButtonStyleName ? createButtonStyleName : "poker-watch-create-team-button-not-active"} data-e2e="team-cancel" onClick={isError ? '' : actionPerform}>{createButtonLable ? createButtonLable : 'create'}</button>
        </div>}
    </div>
}
export const CreateTeam = props => {
    //console.log('****', props);
    return <div className="poker-watch-create-team-div">
        <span className="input-lable" data-e2e="skip">Stable Name</span>
        <input type="text" className="poker-watch-create-team-text" placeholder="The A Stable" data-e2e="stable name"
            onChange={e => props.verifyUnique(e, 'stableName')}  ></input>
        {props.isTeamAlreadyExist > 0 ? <span className="create-stable-owner-lable">Stable Name should be unique</span> : ''}
        <span className="input-lable">Assign Stable Owner</span>
        <input type="text" className="poker-watch-create-team-text" placeholder="Eg: John Doe" data-e2e="stable owner"
            onChange={(event) => { props.handleInputChange(event, { "type": "ownerDetails", "inputObj": { "name": event.target.value } }) }} value={props.creatTeamObj.name}></input>
        {props.isOwnerAlreadyExist > 0 ? <span className="create-stable-owner-lable" >Stable Name should be unique</span> : ''}
        {props.ownerNameData && props.ownerNameData.length > 0 ? <Suggestions data={props.ownerNameData} actionPerform={props.action} elemClass={'stable-owner-suggestion'} /> : ''}
        <span className="create-stable-owner-lable" onClick={e => props.updateObject('owner')} style={{ cursor: 'pointer' }} data-e2e="create-new-stable-owner"> Or create new Stable Owner</span><br />
        {props.errorOBj.createTeamError ? <span className="create-stable-owner-lable">{props.errorOBj.createTeamError}</span> : ''}
    </div>
}
export const CreateOwner = props => {
    return <div className="poker-watch-create-team-div">
        <span className="input-lable" data-e2e="skip">User Email</span>
        <input type="text" className="poker-watch-create-team-text" placeholder="The A Stable" data-e2e="user-email" onBlur={(event) => { props.handleInputChange(event, { "type": "ownerDetails", "inputObj": { "email": event.target.value } }) }}></input>
        {props.errorOBj.emailError && <span className="create-stable-owner-lable" data-e2e="emailError">{props.errorOBj.emailError}</span>}
        <span className="input-lable">Full Name</span>
        <input type="text" className="poker-watch-create-team-text" placeholder="Eg: John Doe" data-e2e="team-name"
            onBlur={(event) => { props.handleInputChange(event, { "type": "ownerDetails", "inputObj": { "fullName": event.target.value, "name": event.target.value } }) }}></input>
        {props.errorOBj.fullNameError && <span className="create-stable-owner-lable" data-e2e="teamNameError">{props.errorOBj.fullNameError}</span>}
        <span className="input-lable">User Password</span>
        <input type="password" className="poker-watch-create-team-text" placeholder="*******" data-e2e="owner-password"
            onChange={(event) => { props.handleInputChange(event, { "type": "password", "inputObj": { "password": event.target.value } }) }}></input>

        {props.errorOBj.createTeamError ? <span className="create-stable-owner-lable">{props.errorOBj.createTeamError}</span> : ''}
    </div>
}
export const Role = props => {
    const { handleRoleChange, creatTeamObj } = props
    return <div className="">
        <select className="form-control2 pokerwatch-team-filet-select" data-e2e="gametype" style={{ height: '32.5px' }}
            value={creatTeamObj && creatTeamObj.roleValue || ''} onChange={(event) => handleRoleChange(event)}>
            <option value=""></option>
            <option value="SYS_ADMIN">Admin</option>
            <option value="BUSINESS_OWNER">Stable Owner</option>
            <option value="COACH">Coach</option>

        </select>
    </div>
}
export const ChangeRoleRadio = props => {
    const { enableUserProp, handleRoleChange, creatTeamObj, dialogContent } = props
    return <div className="change_role_div_radio">

        <span>Admin<input type="radio" id="SYS_ADMIN" name="row" className="change-role-radio-input" value="SYS_ADMIN"
            checked={
                (creatTeamObj && creatTeamObj.roleValue) ? creatTeamObj.roleValue === 'SYS_ADMIN' : enableUserProp.row ? enableUserProp.row.role === 'SYS_ADMIN' : false
            }
            onChange={(event) => handleRoleChange(event)}
        />
        </span>
        <span>Stable Owner <input type="radio" className="change-role-radio-input" id="BUSINESS_OWNER" name="row" value="BUSINESS_OWNER"
            checked={
                (creatTeamObj && creatTeamObj.roleValue) ? creatTeamObj.roleValue === 'BUSINESS_OWNER' : enableUserProp.row ? enableUserProp.row.role === 'BUSINESS_OWNER' : false
            }
            onChange={(event) => handleRoleChange(event)}
        />
        </span>
        <span >Coach<input type="radio" id="COACH" className="change-role-radio-input" name="row" value="COACH"
            checked={
                (creatTeamObj && creatTeamObj.roleValue) ? creatTeamObj.roleValue === 'COACH' : enableUserProp.row ? enableUserProp.row.role === 'COACH' : false
            }
            onChange={(event) => handleRoleChange(event)}
        /> </span>
    </div>
}
export const ChangeRole = props => {
    const { enableUserProp, handleRoleChange, creatTeamObj, dialogContent } = props
    console.log("ChangeRole", creatTeamObj.roleValue);
    return window.innerWidth <= 1024 ? <ChangeRoleRadio {...props} /> : <div className="change_role_div">
        <select className="form-control2 pokerwatch-team-filet-select" data-e2e={creatTeamObj} style={{ width: '349px' }}
            value={(creatTeamObj && creatTeamObj.roleValue) ? creatTeamObj.roleValue : enableUserProp.row ? enableUserProp.row.role : ''} onChange={(event) => handleRoleChange(event)} data-e2e={enableUserProp.row.role}>
            <option value="SYS_ADMIN">Admin</option>
            <option value="BUSINESS_OWNER">Stable Owner</option>
            <option value="COACH">Coach</option>

        </select>

    </div>
}
export const CreateUser = props => {
    const { creatTeamObj } = props;
    console.log('props CreateUser',props);
    return <div className="poker-watch-create-team-div">
        <span className="input-lable">User Email</span>
        <input type="text" className="poker-watch-create-team-text" placeholder="User Email" data-e2e="team-name"
            onBlur={() => props.verifyUserEmailOrAccountName()}
            onChange={(event) => { props.handleInputChange(event, { "type": "createUser", "inputObj": { "email": event.target.value } }) }}></input>
        {props.errorOBj.emailError && <span className="create-stable-owner-lable">{window.innerWidth>1024?props.errorOBj.emailError:"The email has been taken"}</span>}
        <span className="input-lable">Full Name</span>
        <input type="text" className="poker-watch-create-team-text" placeholder="Eg: John Doe" data-e2e="team-name"
            onBlur={() => props.verifyUserEmailOrAccountName()}
            onChange={(event) => { props.handleInputChange(event, { "type": "createUser", "inputObj": { "fullName": event.target.value, "name": event.target.value } }) }}></input>
        {props.errorOBj.fullNameError && <span className="create-stable-owner-lable">{window.innerWidth>1024?props.errorOBj.fullNameError:"The name has been taken"}</span>}
        <span className="input-lable">User Password</span>
        <input type="password" className="poker-watch-create-team-text" placeholder="*******" data-e2e="owner-password"
            onChange={(event) => { props.handleInputChange(event, { "type": "password", "inputObj": { "password": event.target.value } }) }}></input>

        {props.errorOBj.createTeamError ? <span className="create-stable-owner-lable">{props.errorOBj.createTeamError}</span> : ''}
        <span className="input-lable">Role</span>
        <Role {...props} />
    </div>
}
export const EditUser = props => {
    const { enableUserProp, creatTeamObj } = props;
    console.log('in Edit User', creatTeamObj, props.errorOBj)
    return <div className="poker-watch-create-team-div">
        <span className="input-lable">User Email</span>
        <input type="text" className="poker-watch-create-team-text" placeholder="The A Stable" data-e2e="user-email-edit"
            onBlur={() => props.verifyUserEmailOrAccountName()}
            // disabled ={!creatTeamObj.isEmailEditable ?"disabled":'' }
            // style={!creatTeamObj.isEmailEditable ? {backgroundColor:"lightgray"}:{}}
            onChange={(event) => { props.handleInputChange(event, { "type": "editUser", "inputObj": { "email": event.target.value } }) }} value={creatTeamObj.email || enableUserProp.row.username}></input>
        {/* {!creatTeamObj.isEmailEditable &&<i className="fa fa-lg fa-edit" style={{color:'red',marginLeft:'-3rem',marginTop:'10px'}} onClick = {()=>props.enablePasswordEdit("isEmailEditable")}></i>} */}
        {props.errorOBj.emailError && <span className="create-stable-owner-lable">{props.errorOBj.emailError}</span>}
        <span className="input-lable">Full Name</span>
        <input type="text" className="poker-watch-create-team-text"
            style={enableUserProp.row.accountName && enableUserProp.row.accountName != "" ? { cursor: 'not-allowed' } : {}}
            // style ={enableUserProp.row.accountName && enableUserProp.row.accountName!=""?{backgroundColor:"lightgray"}:{}}
            placeholder="Eg: John Doe" data-e2e="team-name"
            onBlur={() => props.verifyUserEmailOrAccountName()}
            disabled={(enableUserProp.row.accountName && enableUserProp.row.accountName != "") ? "disabled" : ""} value={creatTeamObj.fullName || enableUserProp.row.accountName}
            onChange={(event) => { enableUserProp.row.accountName && enableUserProp.row.accountName != "" ? '' : props.handleInputChange(event, { "type": "editUser", "inputObj": { "fullName": event.target.value, "name": event.target.value } }) }}></input>
        {props.errorOBj.fullNameError && <span className="create-stable-owner-lable">{props.errorOBj.fullNameError}</span>}
        <span className="input-lable">User Password</span>
        <input type="password" className="poker-watch-create-team-text" placeholder="*******" data-e2e="owner-password"
            // disabled ={!creatTeamObj.isPasswordEditable ?"disabled":'' }
            // style={!creatTeamObj.isPasswordEditable ? {backgroundColor:"lightgray"}:{}}
            onChange={(event) => { props.handleInputChange(event, { "type": "password", "inputObj": { "password": event.target.value } }) }} />
        {/* {!creatTeamObj.isPasswordEditable &&<i className="fa fa-lg fa-edit" style={{color:'red',marginLeft:'-3rem',marginTop:'10px'}} onClick = {()=>props.enablePasswordEdit("isPasswordEditable")}></i>} */}

        {props.errorOBj.createTeamError ? <span className="create-stable-owner-lable">{props.errorOBj.createTeamError}</span> : ''}
    </div>
}


export const LoginTrackingHistory = props => {
    const { userHistory } = props;
    return <div style={{ height: '248px', marginTop: '19px' }}>
        <table className="pokerwatch-resp-table pw_loginView_list_table">
            <thead className="pw_loginView_list_table_header">
                <tr >
                    <th className="pokerwatch-loginView-table-th">Access Date </th>
                    <th className="pokerwatch-loginView-table-th">IP Addres</th>
                    <th className="pokerwatch-loginView-table-th">Action </th>
                </tr>
            </thead>
            <tbody data-e2e="tableData" className="loginView-list-table">
                {userHistory && userHistory.map((item, key) => {
                    return (
                        <tr key={key}>
                            <td className="pokerwatch-loginView-table-td"> {moment(item.accessedDate).format("YYYY-MM-DD HH:mm:ss")}</td>
                            <td className="pokerwatch-loginView-table-td" >{item.accessIps}</td>
                            <td className="pokerwatch-loginView-table-td">{item.action}</td>
                        </tr>
                    )
                })}

            </tbody>
        </table>

    </div>

}


/** WEBPACK FOOTER **
 ** ./src/components/PokerWatchNew/pokerwatchCommonComponents.js
 **/